import { TransactionAccount } from '@css-xp/graphtypes';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import React from 'react';
import { FormData, PartnerPromotionType } from './subscription-txa-transfer-pane';
import { SelectedBillingAccountTable } from './progress-forms/selected-billing-account-table';
import { SelectedBillingProfileTable } from './progress-forms/selected-billing-profile-table';
import { ConfirmSubscriptionTransfer } from './progress-forms/confirm-subscription-transfer';
import { PartnerDiscountSection } from './progress-forms/partner-discount-section';

interface Props {
  formState: FormData;
  setCurrFormState: (formState: FormData) => void;
  changeBillingAccount: () => void;
  entitlement: EntitlementDetails;
  transactionAccount: TransactionAccount;
  setDisabled?: React.Dispatch<React.SetStateAction<boolean>>;
  partnerPromotionData?: PartnerPromotionType;
}

export const ConfirmTransfer = ({
  formState,
  transactionAccount,
  entitlement,
  setCurrFormState,
  setDisabled,
  changeBillingAccount,
  partnerPromotionData,
}: Props) => {
  return (
    <>
      <div className="invoice-groups-tab" data-testid="confirm-subscription-transfer">
        <SelectedBillingAccountTable
          formState={formState}
          isChangeAvailable={false}
          changeBillingAccount={changeBillingAccount}
        />

        <SelectedBillingProfileTable formState={formState} />

        <PartnerDiscountSection partnerPromotionData={partnerPromotionData} entitlement={entitlement} />

        <ConfirmSubscriptionTransfer
          setCurrFormState={setCurrFormState}
          formState={formState}
          setDisabled={setDisabled}
          transactionAccount={transactionAccount}
        />
      </div>
    </>
  );
};
